/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function FederalElection2025Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Federal Election Information"
              description={
                <>
                  <h4>
                  A federal election is currently underway in Canada. Election day in Canada is April 28, 2025.
                  </h4>
                  <br /><p> <b>If you have questions about the current federal election, please contact Elections Canada at 1-800-463-6868 or visit <u><a href="https://www.elections.ca/home.aspx">elections.ca</a></u>.</b></p>
                  
                  <br /><p>Federal elections are administered by Elections Canada and are outside the mandate of Elections Nova Scotia.</p>
                  <br /><p>Elections at the Federal level provide voters across the country an opportunity to elect Members of Parliament (MPs). The results of a federal election determine which political party will form the federal government with their leader being Prime Minster of Canada.</p>
                  <br /><p>Elections Nova Scotia is a non-partisan and independent agency responsible for conducting provincial elections. Provincial elections provide voters in Nova Scotia an opportunity to elect Members of the Legislative Assembly (MLAs). The results of a provincial general election determine which political party will form the provincial government with their leader being Premier of Nova Scotia.</p>
                  
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FederalElection2025Information;
